import { createAction, props } from '@ngrx/store';
import { Container } from '../_models';

// Action types
export const loadContainers = createAction('[Container] Container Containers');
export const loadContainersSuccess = createAction(
  '[Container] Container Containers Success',
  props<{ containers: Container[] }>()
);
export const loadContainersFailure = createAction(
  '[Container] Container Containers Failure',
  props<{ error: any }>()
);

export const addContainer = createAction(
  '[Container] Add Container',
  props<{ container: Container }>()
);
export const addContainerSuccess = createAction(
  '[Container] Add Container Success',
  props<{ container: Container }>()
);
export const addContainerFailure = createAction(
  '[Container] Add Container Failure',
  props<{ error: any }>()
);

export const updateContainer = createAction(
  '[Container] Update Container',
  props<{ container: Container }>()
);
export const updateContainerSuccess = createAction(
  '[Container] Update Container Success',
  props<{ container: Container }>()
);
export const updateContainerFailure = createAction(
  '[Container] Update Container Failure',
  props<{ error: any }>()
);

export const deleteContainer = createAction(
  '[Container] Delete Container',
  props<{ id: number }>()
);
export const deleteContainerSuccess = createAction(
  '[Container] Delete Container Success',
  props<{ id: number }>()
);
export const deleteContainerFailure = createAction(
  '[Container] Delete Container Failure',
  props<{ error: any }>()
);
